import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import Conversation from "./Conversation";
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";
import AdvertEdit from "./AdvertEdit";
import {Button, Col} from 'reactstrap';
import Loading from "components/Loading";
import {formatPhone} from "helpers/phone";

class Advert extends React.Component {
    static propTypes = {
        advert: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            profiles: PropTypes.array.isRequired,
        }).isRequired,
        onSearchChange: PropTypes.func.isRequired,
        serviceTypeValues: PropTypes.array.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        onAdvertEdit: PropTypes.func.isRequired,
        selectedConversationId: PropTypes.number,
        onLoadMoreProfiles: PropTypes.func.isRequired,
        canHaveHappyHours: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.searchTimeoutTimer = null;

        this.onSearchInputChange = this.onSearchInputChange.bind(this);
    }

    componentWillMount() {
        this.setState({
            loadingMore: false,
            showAdvanced: false
        });
    }

    componentWillUnmount() {
        this.props.onSearchChange(null);
    }

    onSearchInputChange(event) {
        const value = event.target.value;

        this.setState({
            showAdvanced: !!value
        });

        // Prevent request on every change
        if (this.searchTimeoutTimer) {
            clearTimeout(this.searchTimeoutTimer);
        }
        this.searchTimeoutTimer = setTimeout(() => this.props.onSearchChange(value), 200);
    }

    loadMore() {
        this.setState({
            loadingMore: true,
        });
        this.props.onLoadMoreProfiles().then(() => {
            this.setState({
                loadingMore: false
            });
        });
    }

    render() {
        const {advert, serviceTypeValues, priceValuesVoice, priceValuesSms, onAdvertEdit, selectedConversationId, canHaveHappyHours} = this.props;
        const {showAdvanced} = this.state;

        return (
            <div className="call">
                <div className="call__head">
                    <div className="call__head--title">
                        <div className="call__title">
                            <h2>{advert.name}</h2>
                        </div>
                        <div className="call__meta">
                            <AdvertEdit advert={advert} serviceTypeValues={serviceTypeValues} priceValuesVoice={priceValuesVoice} priceValuesSms={priceValuesSms}
                                        onAdvertEdit={model => onAdvertEdit(advert.id, model)} canHaveHappyHours={canHaveHappyHours}/>
                        </div>
                    </div>
                    <div className="call__phone">
                        {advert.publicNumbers.map(number => formatPhone(number)).join(', ')}
                    </div>
                </div>

                <div className="call__search">
                    <FormattedMessage id="conversation.search" defaultMessage="Search" children={message => (
                        <input type="text" placeholder={message} className="form-control"
                               onChange={this.onSearchInputChange}/>
                    )}/>
                </div>

                <div className="call__list">
                    {advert.profiles.map(conversation => (
                        <Conversation key={"conversation-" + conversation.id} advert={advert}
                                      conversation={conversation} selected={conversation.id === selectedConversationId}/>
                    ))}

                    {advert.profiles.length < advert.numProfiles &&
                    <Col className='mt-2'>
                        <Button block color="secondary" onClick={::this.loadMore} disabled={this.state.loadingMore}>
                            {this.state.loadingMore &&
                            <Loading inline small />
                            }
                            <FormattedMessage id="load_more" defaultMessage="Load more"/>
                        </Button>
                    </Col>
                    }

                    {advert.profiles.length === 0 && !showAdvanced /* identifies filter usage */ &&
                    <Col className="text-center call__list--empty">
                        <FormattedMessage id="conversation.no_conversations" defaultMessage="There are no conversations for this profile" />
                    </Col>
                    }

                    {advert.profiles.length === 0 && showAdvanced /* identifies filter usage */ &&
                    <Col className="text-center call__list--empty">
                        <FormattedMessage id="conversation.no_filtered_conversations" defaultMessage="There are no conversations matching your description" />
                    </Col>
                    }
                </div>

                {showAdvanced &&
                <div className="text-center m-2">
                    <Link to={generateUrl(routes.catalogue)} className="btn btn-secondary btn-block">
                        <FormattedMessage id="conversation.advanced_search" defaultMessage="Advanced search"/>
                    </Link>
                </div>
                }

            </div>
        )
    }
}

export default Advert;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Controls/Advert.jsx